//
//
//
//
//
//
//
//
//

import submitSuccess from '@/images/submitSuccess.png'
export default {
  name: 'success',
  data () {
    return {
      imgs: {
        submitSuccess
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/questionnaire/success.vue